import { ChangeDetectorRef,Component } from '@angular/core';
   
import { Employee } from '../../interfaces/employee.interface'; 
import { EmployeeService } from "../../services/employee";
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-add-employee',
  imports: [ReactiveFormsModule],
  templateUrl: './add-employee.html',
  styleUrl: './add-employee.css'
})
export class AddEmployeeComponent {

  employees: Employee[] = [];
  myForm: FormGroup;

 constructor(private employeeService: EmployeeService, 
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                  fname: new FormControl('',[Validators.required,Validators.maxLength(50)]),
                  lname: new FormControl('',[Validators.required,Validators.maxLength(50)]),
                  employeecode: new FormControl('',[Validators.maxLength(25)]),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }

async addEmployee(): Promise<void>
  {
    var fname = this.myForm.value.fname != null ? this.myForm.value.fname.trim() : "";
    var lname = this.myForm.value.lname != null ? this.myForm.value.lname.trim() : "";
    var employeecode = this.myForm.value.employeecode != null ? this.myForm.value.employeecode.trim() : "";
    var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

 try
        {
          await this.employeeService.create(fname,lname,employeecode,uploaded);
          this.cdr.detectChanges();
          this.router.navigateByUrl('employee'); 
        } catch (error) {
          console.error('createstock error',error);
        }

  }   

get fname() { return this.myForm.get('fname'); }
get lname() { return this.myForm.get('lname'); }
get employeecode() { return this.myForm.get('employeecode'); }
get uploaded() { return this.myForm.get('uploaded'); }

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('employee');
  }

}
